import { EtiquetasGenerales_ES } from './Genericos/EtiquetasGenerales_ES';

const EtiquetasModulo = {
    LoginScreen: {
        Et_BotonAccionAcceso: "INICIAR SESIÓN",
        Et_BotonAccionAccesoAAD: "Continuar con Office 365",
        Et_TituloPrincipal: "¡Hola!",
        Et_txtUsuario: "Dirección de Correo *",
        Et_txtPassword: "Contraseña *",
        Et_txtRemenber: "Recuérdame",
        Et_txtLoginExterno: "Iniciar sesión con ",
        Et_RecuperarCont: "¿Se le olvidó su contraseña?",
        Et_Copyright: "Copyright © 2025 CLASS Limitless,  is a trademark",
    },    
    PerfilUsuario: {
        Et_BotonAccion: "Guardar Datos",
        Et_TituloPrincipal: "Perfil Usuario",
        Et_txtNombre: "Nombre *",
        Et_txtApellidos: "Apellidos *",
        Et_txtCorreo: "Dirección de Correo *",
        Et_txtNotificaciones: "Quiero recibir noticias y actualizaciones por correo",
        Et_txtContrasena: "Contraseña *",
        Et_txConfirmarContrasena: "Confirmar contraseña *",
        Et_btnSelecionImagen: "Seleccione una imagen"
    },
    RegistrarUsuario: {
        Et_BotonAccion: "REGISTRAME",
        Et_TituloPrincipal: "Registro",
        Et_txtNombre: "Nombre *",
        Et_txtApellidos: "Apellidos *",
        Et_txtCorreo: "Dirección de Correo *",
        Et_txtNotificaciones: "Quiero recibir noticias y actualizaciones por correo",
        Et_txtContrasena: "Contraseña *",
        Et_txConfirmarContrasena: "Confirmar contraseña *"
    },
    RecuperarContrasena: {
        Et_BotonAccion: "CONTINUAR",
        Et_BotonRegresar: "REGRESAR",
        Et_TituloPrincipal: "¿Olvidó su contraseña?",
        Et_Cuerpo: "Escriba una dirección de correo y nosotros con gusto le enviaremos un enlace para que usted agregue la nueva contraseña.",
        Et_txtCorreo: "Dirección de Correo *"
    },
    CambiarContrasena: {
        Et_BotonAccion: "CAMBIAR",
        Et_BotonRegresar: "REGRESAR",
        Et_TituloPrincipal: "¿Olvidó su contraseña?",
        Et_Cuerpo: "Políticas de contraseñas",
        Et_txtContrasena: "Nueva contraseña *",
        Et_txtConfirmar: "Confirmar contraseña *"
    },
    PoliticasContrasena: {
        Et_PoliticasContrasena: "Políticas Contraseñas",
        Et_Minimo: "Tamaño mínimo: ",
        Et_Maximo: "Tamaño máximo: ",
        Et_Numeros: "Caracteres numéricos",
        Et_Vocales: "Debe ingresar al menos una vocal",
        Et_Mayuscula: "Debe ingresar al menos una letra mayúscula",
        Et_Minuscula: "Debe ingresar al menos una letra minúscula",
        Et_CEspecial: "Debe ingresar al menos un carácter especial",
        Et_Confirmacion: "Coincide con la contraseña de confirmación",
        Et_Historico: "La contraseña no se puede repetir a las últimas ",
        Et_Caracteres: " caracteres"
    },
    RecuperarContrasenaSatisfactorio: {
        Et_TituloPrincipal: "!Revise su correo!",
        Et_Cuerpo: "Le acabamos de enviar un correo con las instrucciones para que pueda cambiar de contraseña e iniciar sesión nuevamente.",
        Et_TxtCorreo: "Si tiene alguna preguntas que hacernos o algún problema, escríbanos a este correo: ",
        Et_Correo: "class-u@gmail.com",
        Et_BotonRegresar: "INICIAR SESIÓN",
    },
    PlantillaCorreo: {
        Et_Topic: "Recuperación contraseña",
        Et_Header: "Estimado: ",
        Et_Body: "Este correo fue enviado automáticamente para restablecer su contraseña por la solicitud de recuperación realizada el día ",
        Et_Body1: "Por favor ingrese al siguiente enlace para actualizar su contraseña: ",
        Et_Body2: "El enlace tiene una validez de ",
        Et_Body3: " hora(s).",
        Et_Footer: "Saludos, "
    },
    Home: {
        Et_IrTienda: "Ir a la tienda",
        Et_HomeTitulo: '¡Evolución constante!',
        Et_TituloFooter: '© Innovasoft 2025'
    }
};

const EtiquetasUnificadas = { ...EtiquetasGenerales_ES, ...EtiquetasModulo };

const Etiquetas_Es = {
    Idioma: "ES",
    Etiquetas: EtiquetasUnificadas
};

export default Etiquetas_Es;
